import { useState } from 'react'

import { ForgotPassEmailSent } from './components/ForgotPassEmailSent.js'
import { ForgotPasswordForm } from './Forms/ForgotPasswordForm.js'

export const ForgotPassword = () => {
  const [emailAddress, setEmailAddress] = useState('')

  if (emailAddress) {
    return <ForgotPassEmailSent emailAddress={emailAddress} />
  }

  return (
    <ForgotPasswordForm
      onSend={(emailAddress: string) => {
        setEmailAddress(emailAddress)
      }}
    />
  )
}

// Default exports are needed for React.lazy
// See https://reactjs.org/docs/code-splitting.html#named-exports
// eslint-disable-next-line import/no-default-export
export default ForgotPassword
